import { routes } from "./router";
import type { ModuleInitialise } from "@/types";

export const initialiseModule: ModuleInitialise = ({ router }) => {
  routes.map((route) => router.addRoute(route));
};

// MAI-4840 wizard public contract — consumed by MAI-4843's offering detail
// page for settings-section -> wizard-step deep links.
export {
  OFFERING_WIZARD_STEPS,
  visibleSteps,
  getStepByKey,
} from "./wizard/steps";
export { getStepRoute } from "./composables/useOfferingWizardNavigation";
export type {
  OfferingWizardStep,
  OfferingWizardStepKey,
  OfferingWizardForm,
} from "./wizard/types";
